import Text10 from './Text10'
export default Text10
